import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/figmaColors'

export const useStyles = makeStyles()(() => ({
  card: {
    boxSizing: 'border-box',
    width: '100%',
    minHeight: 0,
    backgroundColor: C.cardBg,
    border: `1px solid ${C.divider}`,
    borderRadius: 8,
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    width: '100%',
    flexShrink: 0,
  },
  headerTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    minWidth: 0,
  },
  headerIcon: {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: C.iconBoxBg,
    borderRadius: 4,
    '& svg': { fontSize: 12, color: C.darkText },
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: C.strongText,
    margin: 0,
  },
  scrollWrap: {
    position: 'relative',
    width: '100%',
    flex: '1 1 auto',
    minHeight: 0,
    display: 'flex',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    width: '100%',
    flex: '1 1 auto',
    minHeight: 0,
    maxHeight: 280,
    overflowY: 'auto',
  },
  item: {
    boxSizing: 'border-box',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    padding: '8px 12px',
    borderRadius: 4,
  },
  itemText: {
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: C.darkText,
  },
  // Inline inside the summary sentence, so it inherits the sentence's metrics
  // and only the colour and pointer mark it as the link.
  companyLink: {
    display: 'inline',
    padding: 0,
    border: 'none',
    background: 'none',
    font: 'inherit',
    color: C.linkBlue,
    cursor: 'pointer',
  },
  itemTime: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    color: C.mutedText,
  },
  divider: {
    width: '100%',
    height: 1,
    backgroundColor: C.divider,
  },
  // The shared loader is sized for full-page use with fixed-px internals we
  // can't resize from here, so scale the whole subtree down to fit this card.
  loading: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    '& > *': {
      transform: 'scale(0.6)',
      transformOrigin: 'center',
    },
  },
}))
